//@ts-strict-ignore
import React from 'react';
import EdataProduct from '../../graphql/entities/product/EdataProduct';
import Workspace from '../../components/Workspace/Workspace';
import { useWorkspace } from '../../graphql/hooks/useWorkspace';
import { IEdataProductLight } from '../../graphql/schema/p4types';
import { Paths } from '../../@types/keyOfNested';

const { workspace, type, title } = EdataProduct;

const DEFAULT_COLUMNS: Array<Paths<IEdataProductLight>> = [
  'manufacturerPartNumber',
  'shortDescription',
  'manufacturerName',
  'family',
  'range',
];

const EdataProductLightWorkspace = (props) => {
  const workspaceProps = useWorkspace<IEdataProductLight>(props, EdataProduct, {
    columns: DEFAULT_COLUMNS,
    initialSortColumn: 'manufacturerPartNumber',
  });

  return (
    <Workspace
      ref={props.setWorkspaceRef}
      entityType={type}
      title={title}
      defaultQuery={workspace}
      {...workspaceProps}
      {...props}
      entity={EdataProduct}
      noEdit={true}
    />
  );
};

export default EdataProductLightWorkspace;
